<style src="./ItemAssociation.scss" lang="scss" scoped></style>
<template lang="html">
  <section class="item-association">
  </section>
</template>

<script>

export default {
  name: 'ItemAssociation',
  props: {
    stageId: null,
    eventId: null
  },
  data () {
    return {
      declineReason: ''
    }
  },
  methods: {}
}
</script>



// WEBPACK FOOTER //
// src/components/event/item-association/ItemAssociation.vue